import React, { ReactNode } from 'react';
import DatePicker from 'react-datepicker';

export const Loading = () => {
  return (
    <div className='ui segment'>
      <div className='ui active inverted dimmer'>
        <div className='ui small text loader'>Loading</div>
      </div>
      <br />
      <br />
    </div>
  );
};

export const EmptyList = ({ message }: { message: string }) => {
  return (
    <div className='ui visible message'>
      <p>{message}</p>
    </div>
  );
};

interface DateInputParams {
  label: string;
  stateKey: string;
  date?: Date;
  minDate?: Date;
  maxDate?: Date;
  onChange: (date: Date, event: React.SyntheticEvent<any>) => void;
}

export const DateInput = (params: DateInputParams) => {
  const { stateKey, label, date, minDate, maxDate, onChange } = params;
  const dayClassName = React.useCallback(() => stateKey, [stateKey]);
  return (
    <div className='field'>
      <label>{label}</label>
      <DatePicker
        dateFormat='dd/MM/yyyy'
        dayClassName={dayClassName}
        selected={date}
        minDate={minDate}
        maxDate={maxDate}
        onChange={onChange}
      />
    </div>
  );
};

interface DateRangeParams {
  stateKey: string;
  startLabel?: string;
  startDate?: Date;
  endLabel?: string;
  endDate?: Date;
  onChange: (date: Date, event: React.SyntheticEvent<any>) => void;
}

export const DateRange = (params: DateRangeParams) => {
  const { startLabel = 'Data Inicial', stateKey, startDate, endLabel = 'Data final', endDate, onChange } = params;

  return (
    <div className='two fields'>
      <DateInput
        stateKey={`start${stateKey}`}
        label={startLabel}
        onChange={onChange}
        date={startDate}
        maxDate={endDate}
      />
      <DateInput stateKey={`end${stateKey}`} label={endLabel} onChange={onChange} date={endDate} minDate={startDate} />
    </div>
  );
};

interface AccordionParams {
  target?: string;
  title: string;
  isActive: boolean;
  children?: ReactNode;
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export const Accordion = (params: AccordionParams) => {
  const { isActive, target, title, children, handleClick } = params;
  const activeClass = isActive ? 'active' : '';

  return (
    <div className='ui accordion'>
      <div className={`title ${activeClass}`} data-value={target} onClick={handleClick}>
        <i className='dropdown icon' />
        {title}
      </div>
      <div className={`content ${activeClass}`}>{children}</div>
    </div>
  );
};

export const LoadingField = ({ label }: { label: string }) => {
  return (
    <div className='field'>
      <label>{label}</label>
      <div className='ui left icon input loading disabled'>
        <input />
        <i className='search icon' />
      </div>
    </div>
  );
};
